/* eslint-disable @typescript-eslint/no-explicit-any */
import compact from 'lodash/compact';
const defaultKey = ['objective-traits'];
const keys = {
    default: defaultKey,
    objectiveOwnedTraits: (id, params) => {
        return compact([...defaultKey, 'owned', id, params]);
    },
    objectiveAssignedTraits: (id, params) => {
        return compact([...defaultKey, 'assigned', id, params]);
    }
};
export default keys;
